// extracted by mini-css-extract-plugin
export default {"logo":"Header_logo__HK85R"};